"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOrderForSantanderApplicationQuery = void 0;
const types_1 = require("../../types");
exports.validateOrderForSantanderApplicationQuery = `
    query validateOrderForSantanderApplication($orderId: String!) {
    validateOrderForSantanderApplication(orderId: $orderId) {
      ...validationResult
    }
  }
  ${types_1.validationResultFragment}
`;
//# sourceMappingURL=application.js.map